import Content from './content';
import Button from '@CS/components/Button';
import Save from '@/assets/images/icons/save.svg?component';
import ButtonsContainer from './AvatarOptionsButtons.styles';
import Arrow from '@/assets/images/icons/arrow.svg?component';

type AvatarOptionsButtonsProps = {
  onBackClick?: () => unknown;
  onSaveClick?: () => unknown;
  onNextClick?: () => unknown;

  disabledBack?: boolean;
  disabledSave?: boolean;
  disabledNext?: boolean;
};

export const AvatarOptionsButtons = ({
  disabledBack,
  disabledSave,
  disabledNext,

  onBackClick,
  onSaveClick,
  onNextClick
}: AvatarOptionsButtonsProps) => (
  <ButtonsContainer>
    <Button
      disabled={disabledBack}
      onClick={onBackClick}
      variant="secondary"
      gtmConfig={{
        eventLabel: '/fam-mode-2/creating-avatars',
        eventAction: 'Terug',
        event: 'button_click'
      }}>
      <Arrow />
      {Content.back}
    </Button>

    <Button onClick={onSaveClick} disabled={disabledSave} variant="icon">
      <Save />
    </Button>

    <Button
      disabled={disabledNext}
      onClick={onNextClick}
      gtmConfig={{
        eventLabel: '/family-mode-2/close',
        eventAction: 'close',
        event: 'button_click'
      }}
    >
      {Content.next}
      <Arrow />
    </Button>
  </ButtonsContainer>
);
